import React from "react"
import styled from "styled-components"
import { IProject } from "../../../../types/project"
import Col from "react-bootstrap/Col"
import media from "../../../../helpers/media"

const Shortname = styled.div`
  text-transform: uppercase;
  font-size: var(--font-size-md);
  padding: 5px 5px 0px 5px;
  border-bottom: 1px solid black;
`

const Name = styled.h3`
  font-size: var(--font-size-md);
`

const Place = styled.div`
  display: flex;
  align-items: center;
  font-size: var(--font-size-md);
  font-family: var(--font-secondary);

  img {
    width: 8px;
    transform: translateY(-2px);
  }

  span {
    white-space: nowrap;
  }
`

const Date = styled.div`
  display: flex;
  align-items: center;
  font-size: var(--font-size-md);
  font-family: var(--font-secondary);
  white-space: nowrap;
  margin-left: 30px;
`

const SelectableCard = styled(Col)`
  &.popin-open {
    opacity: 0.5;
  }

  &.active {
    opacity: 1;
  }

  &:hover {
    background: var(--color-grey);
  }
`

const GroupCol = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: calc(100% - 60px);
  justify-content: space-between;

  ${media.mobile} {
    flex-direction: row;
  }
`
const GroupRow = styled.div`
  display: flex;
  flex-basis: 60%;

  &:last-child {
    flex-basis: 40%;

    ${media.mobile} {
      justify-content: space-between;
    }
  }
`

const LineWrapper = styled(SelectableCard)`
  cursor: pointer;
  display: flex;
  align-items: baseline;
  padding: 10px 0;
  color: var(--color-grey-2);

  ${Shortname} {
    border: none;
    padding: 0;
    margin: 0;
    flex-basis: 60px;
    min-width: 60px;
  }
  ${Name} {
    padding: 0 10px 0 0;
    margin: 0;
  }
  ${Place} {
  }
  ${Date} {
  }
`

const FilterGroup = styled.div`
  width: 100%;
  margin-bottom: 30px;
  margin-right: 15px;
  margin-left: 15px;

  ${Shortname}, ${Name}, ${Place}, ${Date} {
    font-size: var(--font-size-sm);
  }
`

const FilterLabel = styled.div`
  font-size: var(--font-size-lg);
  text-transform: lowercase;
  border-bottom: 1px solid var(--color-grey-3);
  padding-bottom: 5px;
  margin-bottom: 5px;
`

const FilterResults = styled.div``

interface IProps {
  name: string
  results: number
  list: IProject[]
  selectProject: (item: IProject) => void
  selectedProject: IProject | undefined
  popinOpen: boolean
}

const ViewList = ({
  name,
  results,
  list,
  selectProject,
  selectedProject,
  popinOpen,
}: IProps): JSX.Element => {
  return (
    <FilterGroup>
      <FilterLabel>
        {name} {/* ({results}) */}
      </FilterLabel>

      <FilterResults>
        {list
          .filter(
            (item: IProject) =>
              item.role && item.role.indexOf(name) >= 0
          )
          .map((item: IProject, i: number) => {
            return (
              <LineWrapper
                sm={12}
                key={i}
                onClick={() => selectProject(item)}
                className={`${
                  item.name === selectedProject?.name ? "active" : ""
                } ${popinOpen ? "popin-open" : ""}`}
              >
                <Shortname>{item.shortname}</Shortname>
                <GroupCol>
                  <GroupRow>
                    <Name>{item.name}</Name>
                  </GroupRow>
                  <GroupRow>
                    <Place>
                      <span>
                        {item.city}{" "}
                        {item.department && `(${item.department})`}
                      </span>
                    </Place>
                    <Date>
                      <span>
                        {Array.isArray(item.date)
                          ? item.date.join("-")
                          : item.date}
                      </span>
                    </Date>
                  </GroupRow>
                </GroupCol>
              </LineWrapper>
            )
          })}
      </FilterResults>
    </FilterGroup>
  )
}

export default ViewList
